module.exports = function(app) {

    app.directive('onlyOneSearchTerm', ['teamsite', function(teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/onlyOneSearchTerm.html'),
            controller: [function() {
            }],
            link: function(scope, element, attrs, controller) {
                var hasOnlyOne = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.onlyOneSearchTerm = function() {
                    hasOnlyOne = false;
                    var searchObj = scope.objEmployerSearch;
                    if (searchObj.theName.length > 0 && searchObj.number.length > 0)
                    {
                        showMsg();
                    } else {
                        hasOnlyOne = true;
                        hideMsg();
                    }
                    return hasOnlyOne;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                var reEvalTheForm = function() {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.onlyOneSearchTerm();
                    }
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('objEmployerSearch.number', function() { reEvalTheForm(); });
                scope.$watch('objEmployerSearch.theName', function() { reEvalTheForm(); });

                var hideMsg = function() {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-only-one-search-term='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function() {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-only-one-search-term='true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    hasOnlyOne = false;
                }

                scope.valStuff.clearNoAlphaInId = function() {
                    hideMsg();
                }

            }
        };
    }]);
    
    app.directive('hasAlphaInId', ['teamsite', function(teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/hasAlphaInId.html'),
            controller: [function() {
            }],
            link: function(scope, element, attrs, controller) {
                // var hasNoAlphaInId = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.hasAlphaInId = function() {
                    var hasAlphaInId = false;
                    var searchObj = scope.objEmployerSearch;
                    // new RegExp(/\b[0-9]{2}\/[0-9]{2}\/[0-9]{4}\b/);
                    if (searchObj.number.length > 0) {
                        var numbersOnly = new RegExp(/^\d+$/);
                        hasAlphaInId = (numbersOnly.test(searchObj.number)) ? false : true;
                        if (hasAlphaInId) {
                            showMsg();
                        } else {
                            // hasNoAlphaInId = false;
                            hideMsg();
                        }
                    } else {
                        // there i
                        // nothing in the box so there can be no validation error
                        hideMsg();
                    }
                    return hasAlphaInId;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                //var reEvalTheForm = function() {
                //    if (scope.submitWasAlreadyClicked) {
                //        scope.valStuff.hasAlphaInId();
                //    }
                //}
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('objEmployerSearch.number', function() {
                    // var searchObj = scope.objEmployerSearch;
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.hasAlphaInId();
                    }


                });

                var hideMsg = function() {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-has-alpha-in-id='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function() {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-has-alpha-in-id='true']").removeClass("hide-val-msg").addClass("show-val-msg");
                }

                scope.valStuff.clearNoAlphaInId = function() {
                    hideMsg();
                }

            }
        };
    }]);
    
    app.directive('sixCharsInId', ['teamsite', function(teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/sixCharsInId.html'),
            controller: [function() {
            }],
            link: function(scope, element, attrs, controller) {
                var hasSixCharsInId = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.hasSixCharsInId = function() {
                    hasSixCharsInId = true;
                    var searchObj = scope.objEmployerSearch;
                    // see if there is a number or a name ----------------------
                    // the requirements is now that number can be 6 or more
                    if ((searchObj.number.length > 0) && (searchObj.number.length < 6))
                    {
                        showMsg();
                    } else {
                        hideMsg();
                    }
                    return hasSixCharsInId;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                var reEvalTheForm = function() {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.hasSixCharsInId();
                    }
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('objEmployerSearch.number', function() { reEvalTheForm(); });

                var hideMsg = function() {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-six-chars-in-id='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function() {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-six-chars-in-id='true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    hasSixCharsInId = false;
                }

                scope.valStuff.clearSixCharsInId = function() {
                    hideMsg();
                }

            }
        };
    }]);

    app.directive('fiveCharsForContains', ['teamsite', function(teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/fiveCharsForContains.html'),
            controller: [function() {
            }],
            link: function(scope, element, attrs, controller) {
                var hasFiveCharacters = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.hasFiveCharactersForContains = function() {
                    var formPasses = scope.valStuff.numberOrId();
                    if (!formPasses) { return; }
                    hasFiveCharacters = true;
                    var searchObj = scope.objEmployerSearch;
                    if(searchObj.number.length>0 || searchObj.theName.length==0) {
                        hideMsg();
                        return true;
                    }
                    // see if there is a number or a name ----------------------
                    if (searchObj.searchQualifier == 'CONTAINS' && searchObj.theName.length<5)
                    {
                        showMsg();
                    } else {
                        hideMsg();
                    }
                    return hasFiveCharacters;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                var reEvalTheForm = function() {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.hasFiveCharactersForContains();
                    }
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('objEmployerSearch.searchQualifier', function() { reEvalTheForm(); });
                scope.$watch('objEmployerSearch.theName', function() { reEvalTheForm(); });
                scope.$watch('objEmployerSearch.number', function() { reEvalTheForm(); });

                var hideMsg = function() {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-five-chars-for-contains='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function() {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-five-chars-for-contains='true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    hasFiveCharacters = false;
                }

                scope.valStuff.clearHasFiveCharacters = function() {
                    hideMsg('fiveCharsForContains');
                }

            }
        };
    }]);
    
    app.directive('threeCharsForBeginsWith', ['teamsite', function(teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/threeCharsForBeginsWith.html'),
            controller: [function() {
            }],
            link: function(scope, element, attrs, controller) {
                var hasThreeCharacters = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.hasThreeCharacters = function() {
                    hasThreeCharacters = true;
                    if ((scope.objEmployerSearch.theName.length) && (scope.objEmployerSearch.theName.length>0)) {
                        // there's a value in the name box
                        var searchObj = scope.objEmployerSearch;
                        // see if there is a number or a name ----------------------
                        if (searchObj.searchQualifier == 'BEGINSWITH' && searchObj.theName.length < 3 && searchObj.number.length == 0) {
                            hasThreeCharacters = false;
                            showMsg();
                        } else {
                            hasThreeCharacters = true;
                            hideMsg();
                        }
                    } else {
                        hasThreeCharacters = true;
                        hideMsg();
                    }
                    return hasThreeCharacters;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                var reEvalTheForm = function() {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.hasThreeCharacters();
                    }
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('objEmployerSearch.searchQualifier', function() {
                    reEvalTheForm();
                });
                scope.$watch('objEmployerSearch.theName', function() { reEvalTheForm(); });
                scope.$watch('objEmployerSearch.number', function() { reEvalTheForm(); });

                var hideMsg = function() {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-three-chars-for-begins-with='true']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function() {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-three-chars-for-begins-with='true']").removeClass("hide-val-msg").addClass("show-val-msg");
                    hasThreeCharacters = false;
                }

                scope.valStuff.clearHasThreeCharacters = function() {
                    hideMsg('threeCharsForBeginsWith');
                }

            }
        };
    }]);

    app.directive('numberOrIdRequired', ['teamsite', function(teamsite) {
        return {
            restrict: 'A',
            replace: true,
            template: require('directives/numberOrIdRequired.html'),
            controller: [function() {
            }],
            link: function(scope, element, attrs, controller) {
                var numberOrId = true;
                // the Submit button hits this to validate the form ==================================
                scope.valStuff.numberOrId = function() {
                    numberOrId = true;
                    var searchObj = scope.objEmployerSearch;
                    // see if there is a number or a name ----------------------
                    if ((searchObj.number == '') && (searchObj.theName == '')) {
                        showMsg('numberOrIdRequired');
                    } else {
                        hideMsg('numberOrIdRequired');
                    }
                    return numberOrId;
                }
                // this runs on $watch, when any member obj property changes --------------------------
                var reEvalTheForm = function() {
                    if (scope.submitWasAlreadyClicked) {
                        scope.valStuff.numberOrId();
                    }
                }
                // we watch each property in the object we will submit to the server =================================
                scope.$watch('objEmployerSearch.number', function() { reEvalTheForm(); });
                scope.$watch('objEmployerSearch.theName', function() { reEvalTheForm(); });

                var hideMsg = function(validatorName) {
                    // in the html validatorName corresponds with
                    // <div data-custom-validator="validatorName" />
                    $("section[data-number-or-id-required='"+validatorName+"']").removeClass("show-val-msg").addClass("hide-val-msg");
                }
                var showMsg = function(validatorName) {
                    // element[0].classList.remove('hide-val-msg')
                    // element[0].classList.add('show-val-msg')
                    $("section[data-number-or-id-required='"+validatorName+"']").removeClass("hide-val-msg").addClass("show-val-msg");
                    numberOrId = false;
                }

                scope.valStuff.clearNumberOrIdRequired = function() {
                    hideMsg('numberOrIdRequired');
                }

            }
        };
    }]);

}
